import { registerAction } from '../../../redux/actions/RegisterCampaignAction'
import { AppDispatch } from '../../../redux/utils/AppDispatch'
import {
  handleSequeiryValidation,
  handleAddressValidation,
  handlePerfonalInfoValidation,
  initialSecurityValues,
  initialAddressValues,
  initialPersonalValues,
} from '../../Auth/Register/constans'

export {
  handleSequeiryValidation,
  handleAddressValidation,
  handlePerfonalInfoValidation,
  initialSecurityValues,
  initialAddressValues,
  initialPersonalValues,
}

export const handleRegisterCampaign = (formValue, token) => {
  const newDate = new Date(formValue.bday.year, formValue.bday.month, formValue.bday.day)
  const registerForm = { ...formValue, bday: newDate, coupon_profile: false }
  if (token) {
    registerForm.store_promotion_token = token
  }
  AppDispatch(registerAction(registerForm))
}
